import ProductGrid from './ProductGrid';
import React, {useState} from 'react';
import {useToast} from '@chakra-ui/react'
import {CompareReel} from './CompareReel';


export default function ProductsIndex() {
    const [productsCompared, setproductsCompared] = useState([])

    const toast = useToast()

    // TODO: Make it paginated


    console.log("Products compared", productsCompared)

    function deleteFromCompared(index) {
        setproductsCompared((prevState) => {
            let newState = [...prevState];
            newState.splice(index, 1);
            return newState;
        })
    }

    function addToCompare(product_obj) {
        console.log("addToCompare Called");
        setproductsCompared(prevState => {
                if (prevState.length >= 2) {
                    console.log("prevState.length >= 2")
                    toast({
                        title: 'Can only compare 2 products together.',
                        description: 'Please remove a product from comparison to add a new product',
                        status: 'info',
                        isClosable: true,
                    })
                    return prevState
                } else {
                    return [...prevState, product_obj]
                }
            }
        )
    }


    return (<>
        <ProductGrid addToCompare={addToCompare}/>
        {productsCompared.length ?
            <CompareReel productsCompared={productsCompared} deleteFromCompared={deleteFromCompared}/>
            : null}
    </>)
}